// extracted by css-extract-rspack-plugin
export default {"cell":"KFWoIzu1GgMMeIYE__cell___","ownerCell":"PPDow8a2gMIQiQW5__ownerCell___"};